<template>
  <!-- 显示设置 -->
  <div v-if="body_data">
    <div class="pro">
      <h2>扫描二维码或复制打开链接进入测评</h2>
      <div id="qrcode"></div>
      <h2>{{url}}</h2>
    </div>
  </div>
</template>
<script>
import {
  previewEvaluation
} from "@/api/measurement";
export default {
  data() {
      return {
        labelWidth: '120px',
        body_data: false,
        url: ''
      }
    },
    methods: {
      pullData() {
        this.$showLoading();
        previewEvaluation({
          eid: this.$route.query.id
        }).then((data) => {
            this.body_data = true;
            this.url = data.url;
            this.generateQeCode();
        }).catch(() => {
          this.$hideLoading();
        });
      },
      // 生成二维码
      generateQeCode() {
        setTimeout(() => {
          let qrcode = new QRCode(document.getElementById("qrcode"), {
            width: 300,
            height: 300,
          });
          qrcode.makeCode(this.url);
          this.$hideLoading();
        }, 200)
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.pro {
  padding: 10px;
  h2 {
    font-size: 20px;
    font-weight: normal;
    line-height: 30px;
  }
}
</style>
